import React, { useEffect, useRef } from "react";

const AnswerComponent = ({ answer, isDark }) => {
  const answerRef = useRef(null);

  useEffect(() => {
    if (answer && answerRef.current) {
      answerRef.current.classList.add("answer-highlight");
      setTimeout(() => {
        answerRef.current.classList.remove("answer-highlight");
      }, 1000);
    }
  }, [answer]);

  return (
    <p
      ref={answerRef}
      className={`mt-1 ${
        isDark ? "text-gray-300" : "text-gray-700"
      } transition-all duration-1000 ease-in-out`}
    >
      A: {answer}
    </p>
  );
};

export default AnswerComponent;
